import { render, staticRenderFns } from "./DashboardLogModal.vue?vue&type=template&id=38a9ca99&"
import script from "./DashboardLogModal.vue?vue&type=script&lang=js&"
export * from "./DashboardLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports